import { render, staticRenderFns } from "./ClassManageExam.vue?vue&type=template&id=81e58b3e&scoped=true"
import script from "./ClassManageExam.vue?vue&type=script&lang=js"
export * from "./ClassManageExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e58b3e",
  null
  
)

export default component.exports